import * as React from "react";
import {
  Dialog,
  DialogType,
  DialogFooter,
  DialogContent,
} from "@fluentui/react/lib/Dialog";
import { PrimaryButton, DefaultButton } from "@fluentui/react/lib/Button";
import { ContextualMenu } from "@fluentui/react/lib/ContextualMenu";
import { Toggle } from "@fluentui/react/lib/Toggle";
import { useBoolean } from "@fluentui/react-hooks";
import { TextField, MaskedTextField } from "@fluentui/react/lib/TextField";
import { useEffect, useState, useRef } from "react";
import axios from "../configuration/axios";

const modalPropsStyles = { main: { maxWidth: "50rem" } };
const dialogContentProps = {
  type: DialogType.normal,
  title: "Create a new user",
  subText:
    "Create a new user and choose if they are allowed to manage your licenses",
};

export const CreateUserDialog = (props) => {
  const [hideDialog, { toggle: toggleHideDialog }] = useBoolean(true);
  const { addUserToList, subscriptionId, setShowExceptionDialog, setTokenExpired } = props;

  const modalProps = React.useMemo(
    () => ({
      isBlocking: true,
      styles: modalPropsStyles,
      dragOptions: false,
    }),
    []
  );

  const [userName, setUserName] = useState("");
  const [userEmail, setUserEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);

  async function createLicenseManagerAsync() {
    var userToCreate = {
      subscriptionId: subscriptionId,
      userName: userName,
      userEmail: userEmail,
      isAdmin: isAdmin,
      userGuid: generateGuid(),
    };
    await postCreateLicenseManager(userToCreate);
    addUserToList(userToCreate);
    toggleHideDialog();
  }

  function onAdminRightsChange(event) {
    if (isAdmin) {
      setIsAdmin(false);
    } else {
      setIsAdmin(true);
    }
  }

  function onUserEmailChange(event) {
    setUserEmail(event.target.value);
  }

  function onUserNameChange(event) {
    setUserName(event.target.value);
  }

  function generateGuid() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
      (
        c ^
        (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
      ).toString(16)
    );
  }

  async function postCreateLicenseManager(userToCreate) {
    if (userToCreate.userName !== "" && userToCreate.userEmail !== "") {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("msalToken")}`,
        },
      };
      const bodyParameters = {
        userName: userToCreate.userName,
        userEmail: userToCreate.userEmail,
        userGuid: userToCreate.userGuid,
        isAdmin: userToCreate.isAdmin,
        subscriptionId: userToCreate.subscriptionId,
      };

      await axios
        .post(
          axios.defaults.baseURL + "/LicenseManager/Create",
          bodyParameters,
          config
        )
        .then((result) => {
          setTokenExpired(false);
        })
        .catch((error) => {
          if (error.response.status === 401) {
            setTokenExpired(true);
          }
        });
    }
  }

  return (
    <>
      <PrimaryButton
        secondaryText="Create User"
        onClick={toggleHideDialog}
        text="Create User"
      />
      <Dialog
        hidden={hideDialog}
        onDismiss={toggleHideDialog}
        dialogContentProps={dialogContentProps}
        modalProps={modalProps}
      >
        <DialogContent>
          <TextField
            required
            label="User name"
            defaultValue=""
            onChange={onUserNameChange}
          />
          <TextField
            required
            label="User email"
            defaultValue=""
            onChange={onUserEmailChange}
          />
          <Toggle
            label="Can manage licenses"
            checked={isAdmin}
            onText="Yes"
            offText="No"
            onChange={onAdminRightsChange}
          />
        </DialogContent>
        <DialogFooter>
          <PrimaryButton onClick={createLicenseManagerAsync} text="Create" />
          <DefaultButton onClick={toggleHideDialog} text="Cancel" />
        </DialogFooter>
      </Dialog>
    </>
  );
};
